import { render } from "./EmploymentStatusCreateEditModal.vue?vue&type=template&id=1f4ca31c"
import script from "./EmploymentStatusCreateEditModal.vue?vue&type=script&lang=js"
export * from "./EmploymentStatusCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__